/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row3_LabelInputs */

const en_mk_cmp_row3_label = /** @type {(inputs: Mk_Cmp_Row3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approval before outbound actions`)
};

const id_mk_cmp_row3_label = /** @type {(inputs: Mk_Cmp_Row3_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persetujuan sebelum aksi keluar`)
};

/**
* | output |
* | --- |
* | "Approval before outbound actions" |
*
* @param {Mk_Cmp_Row3_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row3_label = /** @type {((inputs?: Mk_Cmp_Row3_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row3_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row3_label(inputs)
	return en_mk_cmp_row3_label(inputs)
});